module.exports = __webpack_public_path__ + "img/home_innovation-image.7e494255.jpg";